import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { UnconfiguredPage } from '@/features/monitoring'

export const Route = createFileRoute('/_authenticated/monitoring/unconfigured')(
  {
    component: () => (
      <RequirePermission permission='monitoring.read'>
        <UnconfiguredPage />
      </RequirePermission>
    ),
  }
)
